export default __webpack_public_path__ + "static/media/light-green-ball-inverted.1b576f5d.svg";